import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px 0px;\n  > div > div > div {\n    width: auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
import { PasswordInputV4 } from '../PasswordInputV4/PasswordInputV4';
/* The PasswordInputV4CompatibilityWrapper component is 
used to conform FormBuilderV3's props with PasswordInputV4 */

var StyledContainer = styled.div(_templateObject());

var PasswordInputV4CompatibilityWrapper = function PasswordInputV4CompatibilityWrapper(_ref) {
  var values = _ref.values,
      value = _ref.value,
      name = _ref.name,
      handleChange = _ref.handleChange,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["values", "value", "name", "handleChange", "onChange"]);

  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(PasswordInputV4, _extends({
    value: value ? value : values[name],
    name: name
  }, props, {
    onChange: onChange ? onChange : handleChange
  })));
};

export { PasswordInputV4CompatibilityWrapper };